import { status } from "../_constants/commonIVY"
import { correspondenceConstant } from "../_constants/correspondance.constant"

let initialState = {}

export function correspondence(state = initialState, action) {
    switch (action.type) {
        case correspondenceConstant.GET_CORRESPONDENCE_DETAIL_REQUEST:
            return {
                ...state,
                get_correspondence_status: status.IN_PROGRESS,
                get_correspondence_data: null
            }
        case correspondenceConstant.GET_CORRESPONDENCE_DETAIL_SUCCESS:
            return {
                ...state,
                get_correspondence_status: status.SUCCESS,
                get_correspondence_data: action.data,
            }
        case correspondenceConstant.GET_CORRESPONDENCE_DETAIL_FAILURE:
            return {
                ...state,
                get_correspondence_status: status.FAILURE,
                get_correspondence_data: action.data
            }
        case correspondenceConstant.CREATE_CORRESPONDENCE_DETAIL_REQUEST:
            return {
                ...state,
                correspondence_status: status.IN_PROGRESS,
                correspondence_data: null
            }
        case correspondenceConstant.CREATE_CORRESPONDENCE_DETAIL_SUCCESS:
            return {
                ...state,
                correspondence_status: status.SUCCESS,
                correspondence_data: action.data,
            }
        case correspondenceConstant.CREATE_CORRESPONDENCE_DETAIL_FAILURE:
            return {
                ...state,
                correspondence_status: status.FAILURE,
                correspondence_data: null
            }
        case correspondenceConstant.DELETE_CORRESPONDENCE_DETAIL_REQUEST:
            return {
                ...state,
                correspondence_status: status.IN_PROGRESS,
                correspondence_data: null
            }
        case correspondenceConstant.DELETE_CORRESPONDENCE_DETAIL_SUCCESS:
            return {
                ...state,
                correspondence_status: status.SUCCESS,
                correspondence_data: action.data,
            }
        case correspondenceConstant.DELETE_CORRESPONDENCE_DETAIL_FAILURE:
            return {
                ...state,
                correspondence_status: status.FAILURE,
                correspondence_data: null
            }
        case correspondenceConstant.UPDATE_CORRESPONDENCE_DETAIL_REQUEST:
            return {
                ...state,
                correspondence_status: status.IN_PROGRESS,
                correspondence_data: null
            }
        case correspondenceConstant.UPDATE_CORRESPONDENCE_DETAIL_SUCCESS:
            return {
                ...state,
                correspondence_status: status.SUCCESS,
                correspondence_data: action.data,
            }
        case correspondenceConstant.UPDATE_CORRESPONDENCE_DETAIL_FAILURE:
            return {
                ...state,
                correspondence_status: status.FAILURE,
                correspondence_data: null
            }
        default:
            return state;
    }
}